@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.passengers
import com.narbase.letsgo.dto.core.KmmLong

import com.narbase.letsgo.dto.DtoName
import com.narbase.letsgo.dto.core.DateTimeDto
import com.narbase.letsgo.web.models.PhoneNumberType

class PassengerPhoneNumberDto(
    val id: KmmLong? = null,
    val passengerId: KmmLong,
    val callingCode: String,
    val phone: String,
    @Suppress("NON_EXPORTABLE_TYPE") val type: DtoName<PhoneNumberType>,
    val isActive: Boolean,
    val createdOn: DateTimeDto?,
)
